/*
 * Разница в сек. между временем протухания токена и текущей датой.
 */
export const SECOND_DIFF = 30;
